<template>
  <div :class="name">
    <skeleton-basic width="120px" height="22px" />
    <div :class="`${name}__container`">
      <skeleton-basic width="71px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="180px" height="22px" />
    </div>
    <skeleton-basic width="185px" height="22px" />
    <div :class="`${name}__container`">
      <skeleton-basic width="225px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="676px" height="34px" style="margin-bottom: 24px;" />
      <skeleton-basic width="215px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="676px" height="34px" />
    </div>
    <!-- brandSafety & viewability -->
    <div v-for="i in brandSafetyTrackingCount" :key="`${i}brand`" :class="`${name}__brand_safety_skeleton_wrap`">
      <skeleton-basic width="40px" height="22px" style="margin-right: 10px;" />
      <skeleton-basic width="220px" height="14px" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import SkeletonBasic from '@/components/skeleton/basic.vue';
const name = 'ttam-tracking-skeleton';
export default defineComponent({
  name,
  components: {
    SkeletonBasic,
  },
  setup() {
    const brandSafetyTrackingCount = 2;
    return {
      brandSafetyTrackingCount,
      name,
    };
  },
});
</script>

<style lang="scss">
$name: 'ttam-tracking-skeleton';
.#{$name} {
  &__container {
    margin-top: 8px;
    margin-bottom: 24px;
    padding: 16px 24px;
    background: rgba(248, 248, 248, 0.5);
    border-radius: 4px;
  }
  &__brand_safety_skeleton_wrap {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
}
</style>
